import { makeAutoObservable } from 'mobx';

import { HttpClient } from 'services/http-client';
// import { AuthRequestDto, LocationDto } from 'services/data-contracts';

export interface isValid {
  isValid: boolean;
}

class AuthStore {
  // locations?: Array<LocationDto>[];

  constructor() {
    makeAutoObservable(this);
  }


  // *login(data: AuthRequestDto) {
  //   const { status, response } = yield this.api.authenticateCreate(data);
  //   if (status === 200) {
  //     const { token, refreshToken } = response.data.data;

  //     localStorage.setItem('accessToken', token);
  //     localStorage.setItem('refreshToken', refreshToken);
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
}

export default AuthStore;
